// 1. 외부 패키지
import { useMemo } from "react";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import { encNumber, random } from "../../shared/function";
import { useRecoilState } from "recoil";
import basic_detail_atom from "../../atom/basic-detail";

// 4. 타입

const AreaTypeToggle = () => {

	const [basic_detail, setBasicDetail] = useRecoilState(basic_detail_atom);

	const { area_type } = basic_detail;

	const id = useMemo(() => {
		return random(10000, 1000000);
	}, []);

	const left_id = encNumber((id + 502).toString());
	const right_id = encNumber((id + 702).toString());

	const name = useMemo(() => {
		return encNumber(random(10, 9999).toString());
	}, []);

	const onChange = () => {
		setBasicDetail({
			...basic_detail,
			area_type: area_type === 'PY' ? 'SQ' : 'PY',
		});
	};

	return (
		<div className={`unit_toggle`}>
			<input
				type='checkbox'
				className='_left'
				id={left_id}
				name={name}
				onChange={onChange}
				checked={area_type === 'PY'}
			/>
			<label htmlFor={left_id}>평</label>
			<input
				type='checkbox'
				className='_right'
				id={right_id}
				name={name}
				onChange={onChange}
				checked={area_type === 'SQ'}
			/>
			<label htmlFor={right_id}>㎡</label>
			<div className='handle'>{area_type === 'PY' ? '평' : '㎡'}</div>
		</div>
	);
};

export default AreaTypeToggle;